import { render, staticRenderFns } from "./CurriculumHeaderT.vue?vue&type=template&id=56c676a4&scoped=true&"
import script from "./CurriculumHeaderT.vue?vue&type=script&lang=ts&"
export * from "./CurriculumHeaderT.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumHeaderT.vue?vue&type=style&index=0&id=56c676a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c676a4",
  null
  
)

export default component.exports